<div class="loader">
	<fa-icon class="spinner" [icon]="['fas', 'loader',]"></fa-icon>
	<span>Zoeken...</span>
</div>